import React from 'react';
import { Header } from '../../Header';
import { BottomNav } from '../../BottomNav';

interface ClientLayoutProps {
  children: React.ReactNode;
}

export function ClientLayout({ children }: ClientLayoutProps) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main className="container mx-auto px-4 py-6 pt-20 pb-24">
        {children}
      </main>
      <BottomNav />
    </div>
  );
}